import {
  GET_CALCULATION_FAILED,
  GET_CALCULATION_REQUESTED,
  GET_CALCULATION_SUCCESS,
  QUICK_CALCULATION_RESET,
  SAVE_CALCULATION,
  NOT_SAVE_CALCULATION,
} from '../actions/actionTypes'
import lodash from 'lodash'

const initialState = {
  calculations: {
    days: '-',
    maxLoanAmount: 0,
    basePercent: 0,
    delayPercent: 0,
    maxAmountToDate: 0,
    overpaymentPerDay: 0,
    overpaymentTotal: 0,
    availableAmount: 0,
    refundAmount: 0,
    couponName: '-',
    estimatedValue: [],
    totalQuantity: 0,
    totalGrossWeight: 0,
    totalPureWeight: 0,
    totalEstimatedValue: 0,
    refundableAmount: { nds: '', deposit: '' },
    checksum: '',
    // custom
    amount: 0,
    endDate: '-'
  },
  loading: false,
  commonError: '',
  wasSaved: false,
  calculationFaild: false
}

const quickCalculationReducer = (state = lodash.cloneDeep(initialState), action) => {
  switch (action.type) {
    case GET_CALCULATION_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_CALCULATION_SUCCESS:
      return {
        ...state,
        loading: false,
        calculationFaild: false,
        calculations: lodash.merge(lodash.cloneDeep(initialState.calculations), action.payload),
        commonError: ''
      }
    case SAVE_CALCULATION:
        return {
          ...state,
          wasSaved: true
        }
    case NOT_SAVE_CALCULATION:
        return {
          ...state,
          wasSaved: false
        }
    case GET_CALCULATION_FAILED:
      return {
        ...state,
        loading: false,
        calculationFaild: true,
        commonError: action.payload
      }
    case QUICK_CALCULATION_RESET:
      return lodash.cloneDeep(initialState)
    default:
      return state
  }
}

export default quickCalculationReducer
